module.exports = __webpack_public_path__ + "static/media/align_right_dark.0c043141.svg";